import { useNavigate } from "react-router-dom-v5-compat";

/**
 * Go back to car shop from car checkout
 */
export const useGoBackToCarSearch = () => {
  const navigate = useNavigate();
  // TODO(isabela): replace path when it is included in core
  return () => navigate(`/cars`, { replace: true });
};
